import { render, staticRenderFns } from "./EntryPrimitiveValue.vue?vue&type=template&id=12b13150&scoped=true&"
import script from "./EntryPrimitiveValue.vue?vue&type=script&lang=js&"
export * from "./EntryPrimitiveValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b13150",
  null
  
)

export default component.exports